export default function ServiceArea() {
  const areas = [
    'Miami Beach',
    'Downtown Miami',
    'Coral Gables',
    'Kendall',
    'Brickell',
    'Coconut Grove',
    'South Broward',
    'Doral',
    'Aventura',
    'Pinecrest',
    'Key Biscayne',
    'Homestead'
  ];

  return (
    <section className="py-20 bg-black relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-yellow-500 uppercase tracking-wider text-sm font-semibold mb-3">
            WHERE WE SERVE
          </p>
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6">
            Service Area
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            We serve a 30-mile radius around Miami, bringing premium mobile detailing directly to your location.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Map */}
          <div className="relative rounded-2xl overflow-hidden border-2 border-yellow-500/30 shadow-2xl">
            <div className="relative w-full h-96">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d230270.2698536!2d-80.43656!3d25.7616798!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d9b0a20ec8c111%3A0xff96f271ddad4f65!2sMiami%2C%20FL!5e0!3m2!1sen!2sus!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Miami service area map"
              ></iframe>
            </div>
            
            {/* Radius Overlay */}
            <div className="absolute inset-0 pointer-events-none flex items-center justify-center">
              <div className="relative">
                <div className="w-64 h-64 border-4 border-yellow-500/60 rounded-full animate-pulse"></div>
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-yellow-500 text-black px-4 py-2 rounded-full font-bold text-sm shadow-xl">
                  30-Mile Radius
                </div>
              </div>
            </div>
          </div>

          {/* Areas List */}
          <div>
            <h3 className="text-3xl font-bold text-white mb-6">
              Areas We Cover
            </h3>
            <p className="text-gray-300 mb-8 leading-relaxed">
              Serving a 30-mile radius around Miami—including Kendall, South Broward & more. We bring our mobile detailing service to your home, office, or any convenient location.
            </p>

            {/* Areas Grid */}
            <div className="grid grid-cols-2 gap-4 mb-8">
              {areas.map((area, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3 bg-gray-900/50 border border-yellow-500/20 rounded-lg px-4 py-3 hover:border-yellow-500/40 transition-all"
                >
                  <i className="ri-map-pin-fill text-yellow-500 text-lg"></i>
                  <span className="text-white font-semibold text-sm">{area}</span>
                </div>
              ))}
            </div>

            {/* Not Sure CTA */}
            <div className="bg-gradient-to-br from-gray-900 to-black border-2 border-yellow-500/40 rounded-xl p-6">
              <h4 className="text-yellow-500 font-bold text-lg mb-2 flex items-center gap-2">
                <i className="ri-question-line"></i>
                Not Sure If We Cover Your Area?
              </h4>
              <p className="text-gray-300 text-sm mb-4">
                Text us your location and we'll confirm if we can service your area. We're always expanding our coverage!
              </p>
              <a
                href="sms:+17863272644"
                className="bg-yellow-500 text-black px-6 py-3 rounded-full font-bold hover:bg-yellow-400 transition-all inline-flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer shadow-lg shadow-yellow-500/30"
              >
                <i className="ri-message-3-line"></i>
                Text Us (786) 327-2644
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
